import type { Component } from "vue";

export const routes = [
  // TODO: Implement Routes - I think this is done?
  {
    path: "/inventory/manage",
    name: "inventory-manager",
    component: (): Promise<Component> => import("./views/InventoryManager.vue"),
    meta: { requiresAuth: true, requiredRoles: [], requiredGroups: [] },
  },
];
